class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.vsp = window.vsp || {};
    window.vsp.cartDrawer = this;
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.update(), { once: true });
    } else {
      this.update();
    }
  }
  bindButtons() {
    let removeButtons = this.querySelectorAll(".cart__remove");
    const _this = this;
    removeButtons.forEach(function(removeButton) {
      removeButton.addEventListener("click", _this.onRemoveItemClicked.bind(_this));
    });
  }
  disconnectedCallback() {
  }
  updateAndShow() {
    this.logViewAfterUpdate = true;
    this.update();
    if (document.body.getAttribute("data-visible-overlay") !== "cart") {
      vsp.showOverlay("cart");
    }
  }
  update() {
    fetch(this.getAttribute("data-cart-path")).then((response) => response.text()).then((responseText) => {
      const responseHTML = document.createRange().createContextualFragment(responseText);
      const html = responseHTML.querySelector("#shopify-section-main-cart");
      let cartCount = 0;
      if (html.querySelector(".cart-wrap")) {
        cartCount = html.querySelector(".cart-wrap").getAttribute("data-cart-count");
      }
      if (window.vsp && vsp.updateCartCount) {
        vsp.updateCartCount(cartCount);
      }
      if (window.vsp && vsp.preserveActiveCartWishlistPanel) {
        vsp.preserveActiveCartWishlistPanel(this, html);
      }
      this.querySelector("#CartContainer").replaceChildren(html);
      this.bindButtons();
      if (window.vsp && vsp.renderCartWishlistCounts) {
        vsp.renderCartWishlistCounts(window.swat);
      }
      if (window.vsp && vsp.cartWishlist) {
        vsp.cartWishlist(window.swat);
      }
      if (window.vsp && vsp.cartWishlistViews) {
        vsp.cartWishlistViews(window.swat);
      }
      if (this.logViewAfterUpdate) {
        this.logViewAfterUpdate = false;
        if (document.body.getAttribute("data-visible-overlay") === "cart" && window.vsp && vsp.logCartView) {
          vsp.logCartView("drawer_after_add");
        }
      }
    });
  }
  onRemoveItemClicked(event) {
    const link = event.currentTarget;
    const index = link.dataset.index;
    event.stopPropagation();
    event.preventDefault();
    this.removeItem(index).then((result) => {
      if (result.ok) {
        this.update();
      } else {
        window.location = link.getAttribute("href");
      }
    }).catch((error) => {
      window.location = link.getAttribute("href");
    });
  }
  async removeItem(index) {
    const body = JSON.stringify({
      line: index,
      quantity: 0
    });
    const fetchConfig = {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: `application/json` }
    };
    return fetch(`${routes.cart_change_url}`, { ...fetchConfig, ...{ body } });
  }
}
if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}
